import { render, staticRenderFns } from "./TrenNumeros.vue?vue&type=template&id=18fde9bd"
import script from "./TrenNumeros.vue?vue&type=script&lang=js"
export * from "./TrenNumeros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports